// user.selectors.ts
import { createSelector, createFeatureSelector } from '@ngrx/store';
import { UserState } from '../appState.state';

export const selectUserState = createFeatureSelector<UserState>('user');
export const selectUser = createSelector(selectUserState, state => state.user);
export const selectConnectedUser = createSelector(selectUserState, userState => userState.connectedUser);
